import { render } from "./FounderDetails.vue?vue&type=template&id=0e3c096a&scoped=true"
const script = {}

import "./FounderDetails.vue?vue&type=style&index=0&id=0e3c096a&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-0e3c096a"

export default script